import request from '@/config/axios'

export interface AgentApplyVO {
  id?: number
  applyNo?: string
  profileId?: number
  name?: string
  agentType?: number
  contactName?: string
  contactMobile?: string
  level?: number
  parentId?: number
  parentName?: string
  regionCode?: string
  regionName?: string
  regionExclusive?: boolean
  kycLicenseUrl?: string
  /** 身份证正面 */
  kycIdCardUrl?: string
  /** 身份证反面 */
  kycIdCardBackUrl?: string
  contractSigned?: boolean
  bankName?: string
  bankAccountNo?: string
  bankAccountName?: string
  /** 入驻保证金（分） */
  depositAmount?: number
  clientSource?: string
  status?: number
  rejectReason?: string
  submitTime?: string
  auditTime?: string
  createTime?: string
}

export const getAgentApplyPage = (params: any) =>
  request.get<{ list: AgentApplyVO[]; total: number }>({ url: '/agent/apply/page', params })

export const getAgentApply = (id: number) =>
  request.get<AgentApplyVO>({ url: '/agent/apply/get', params: { id } })

export const createAgentApply = (data: Partial<AgentApplyVO>) =>
  request.post({ url: '/agent/apply/create', data })

export const auditAgentApply = (data: { id: number; approve: boolean; rejectReason?: string }) =>
  request.put({ url: '/agent/apply/audit', data })
